import { useFeatureValue } from '@growthbook/growthbook-react'

import { useRecentlyViewedBannerQuery } from '../../../generated/frontend'
import { RecentlyViewedTextList } from './components/RecentlyViewedTextList/RecentlyViewedTextList'

export const RecentlyViewed = () => {
  const { data, loading, error } = useRecentlyViewedBannerQuery()

  if (loading || error || !data) {
    return null
  }

  const recentlyViewedItems = data?.signupCompletePage?.recentlyViewed?.content || []
  if (recentlyViewedItems.length === 0) {
    return null
  }
  return <RecentlyViewedTextList items={recentlyViewedItems} />
}

export const RecentlyViewedBanner = () => {
  const showRecentlyViewed = useFeatureValue(
    'dsp-029-sitewide-pick-up-where-you-left-off-banner',
    false
  )
  return showRecentlyViewed ? <RecentlyViewed /> : null
}
